/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { LineChart } from './chart';
import { SubtitleCountRenderer } from 'components/virtualTooltip/renderers';
import { useVirtualTooltip } from 'components/virtualTooltip/useVirtualTooltip';
import { useWidgetControlsContext } from 'views/common/WidgetControls';
import { LineChartToolTips } from './lineChartTooltips';

/**
 * Line Chart widget
 * @param getColor
 * @param dimensions {{height: height, width: width}} to define value of chart
 * @param data Array of {key: key, value: value}
 */
export const LineChartWidget = ({ getColor, dimensions, data, yAxisLabel, hideLabels, legendKeys }) => {
	const svgRef = useRef();
	const [chart, setChart] = useState();

	const {dispatch:controlsDispatch, state:controlsState} = useWidgetControlsContext()

	// Filter data to match legend controls
	const [filteredData,setFilteredData] = useState(data)
	useEffect(()=>{
		if(controlsState?.legend) {
			let filteredLines = {...data.lines}
			Object.entries(controlsState.legend.keyValues).forEach(([key,isEnabled])=>{
				if(!isEnabled) filteredLines[key] = []
			})

			// Reconstruct data without disabled data
			const newFilteredData = {
				...data,
				lineKeys:data.lineKeys.filter(
					(k)=>controlsState.legend.keyValues[k]
				),
				rolled:data.rolled.filter(
					(k)=>controlsState.legend.keyValues[k.key]
				),
				lines: filteredLines
			}
			setFilteredData(newFilteredData)
		}
	},[controlsState?.legend,data])

	useEffect(() => {


		const createChart = () => {
			const updateTooltip = (filteredData, location, options) => {}
			return LineChart(svgRef.current, updateTooltip);
		};

		if (filteredData && dimensions && getColor) {
			let ch = chart;

			// if we don't have an existing chart, create one
			if (!ch) {
				ch = createChart();
				setChart(ch);
			}

			ch.update(filteredData, { width: dimensions.width , height: dimensions.height, hideLabels},
					  { colorScale: getColor, yAxisLabel:yAxisLabel });
		}
	}, [chart, filteredData, dimensions, getColor, hideLabels, yAxisLabel]);

	// Keep legend up to date
	useEffect(()=>{
		if(chart) {
			controlsDispatch({
				type:"setLegend",
				payload: {
					keys:legendKeys ? legendKeys : data.rolled.map(k=>k.key),
					colorScale:getColor,
					mouseOver:chart.mouseOver,
					mouseOut:chart.mouseOut,
				}
			})
		}
	},[data.rolled,getColor,controlsDispatch,chart])

	return (
		<div css={chartContainerStyle}>
			<svg
				cy-test="line-chart-data"
				width={dimensions.width}
				height={dimensions.height}
				css={chartStyle}
			>
				<g ref={svgRef} />
			</svg>
			<LineChartToolTips svgRef={svgRef}/>
		</div>
	);
};

LineChartWidget.propTypes = {
	colorScale: PropTypes.any,
	data: PropTypes.any,
	dimensions: PropTypes.object,
};

const chartContainerStyle = css`
	display: flex;
	flex-direction: row;
	align-items: stretch;
	`

const chartStyle = css`
	.gridGroup {
		line,
		path {
			stroke: lightgrey;
			stroke-dasharray: 2;
		}
	}
`;
